import { lookupRelationship } from '@occc-app/lib/client';
import { MarketingContent, Offer } from '@occc-app/Activate/apiTypes';

import { State } from './types';

type MarketingContentParser = (
  offer: Offer,
  included: MarketingContent[],
) => { title: string; description: string };
const marketingContentsParser: MarketingContentParser = (offer, included) => {
  const defaultContent = { title: '', description: '' };
  const marketingContent = lookupRelationship('marketing_contents', offer, included)[0];

  if (typeof marketingContent === 'undefined') {
    return defaultContent;
  }

  return {
    title: marketingContent.attributes.title,
    description: marketingContent.attributes.short_description,
  };
};

type OffersParser = (data: Offer[], included: MarketingContent[]) => State['data']['offers'];
export const offersParser: OffersParser = (data, included) =>
  data.map((apiOffer: Offer) => {
    const marketingContent = marketingContentsParser(apiOffer, included);

    return {
      id: apiOffer.id,
      name: apiOffer.attributes.name,
      title: marketingContent.title,
      category: apiOffer.attributes.category,
      description: marketingContent.description,
      discontinued: apiOffer.attributes.discontinued,
      fulfilled: apiOffer.attributes.fulfillment_count || 0,
      publishAt: apiOffer.attributes.publish_at,
      expireAt: apiOffer.attributes.expire_at,
    };
  });
